import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountVerificationRoutingModule } from './account-verification-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AccountVerificationRoutingModule
  ]
})
export class AccountVerificationModule { }
